import { api } from "@/api/client";
import { FRANQUIA_PATH } from "./api";

export { buscarCep, type ViaCepResponse } from "@/lib/cep";

export interface NovaFranquia {
  nome: string;
  nomeFantasia: string;
  email: string;
  cnpj?: string;
  telefone: string;
  cep?: string;
  rua?: string;
  bairro?: string;
  municipio?: string;
  estado?: string;
  nomeUsuario: string;
  emailUsuario: string;
  usuario: string;
  codigos: string[];
}

export async function saveNovaFranquia(registro: NovaFranquia): Promise<void> {
  await api.post(`${FRANQUIA_PATH}/novafranquia`, registro);
}
